<template>
  <div class="overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <img class="logo" src="https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/tp_logo_white.png" />
        <div class="modal-header-title" v-show="title != ''">{{title}}&nbsp;&nbsp;&nbsp;架构图</div>
        <div class="modal-header-title" v-show="title2 != ''">{{title}}</div>
      </div>
      <div :class="title == '' ? 'modal-header-img2' : 'modal-header-img'">
        <img :src="imglink" />
      </div>
      <img class="close" src="https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/close.png"
        @click="closeModal" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'TopologyDiagram',
  props: {
    title: String,
    title2: String,
    imglink: String
  },
  data() {
    return {
      
    }
  },
  computed: {
    
  },
  mounted() {
    
  },
  updated() {
    
  },
  methods: {
    closeModal() {
      this.$emit('close');
      this.isEdit = false;
    }
  },
  created() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use "sass:math";

@function px2vh($px) {
  @return math.div(100px * $px, 1080px) * 1vh;
}

@font-face {
  font-family: 'SourceHanSansCN-Regular';
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.eot');
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.eot') format('embedded-opentype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.woff') format('woff'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.ttf') format('truetype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'SourceHanSansCN-Bold';
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.eot');
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.eot') format('embedded-opentype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.woff') format('woff'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.ttf') format('truetype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'SourceHanSansCN-Heavy';
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Heavy.eot');
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Heavy.eot') format('embedded-opentype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Heavy.woff') format('woff'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Heavy.ttf') format('truetype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Heavy.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

.textarea {
  width: 90%;
  height: px2vh(120);
  margin: px2vh(24) auto 0;
  display: block;
  padding: 2px;
}

.operate {
  float: right;
  padding-right: 5%;

  button {
    margin: 5px;
    cursor: pointer;
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  overflow-y: scroll;
}

.modal-content {
  background: #F3F3F3;
  //margin: px2vh(94) auto px2vh(86);
  width: px2vh(1300);
  box-sizing: border-box;
  // max-height: px2vh(900);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .modal-header {
    width: 100%;
    height: px2vh(48);
    background: #41558C;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    .logo {
      height: px2vh(14);
      margin-left: px2vh(60);
    }

    .modal-header-title{
      font-family: PingFangSC-Semibold,SourceHanSansCN-Medium;
      font-size: px2vh(18);
      font-weight: normal;
      margin-right: px2vh(60);
      color: #fff;
    }
    
  }

  .modal-header-img{
    width: px2vh(1036);
    margin: px2vh(12) auto;
    img{
      display: block;
      width: 100%;
    }
  }

  .modal-header-img2{
    width: px2vh(820);
    margin: 0 auto;
    img{
      display: block;
      width: 100%;
    }
  }

  .close {
    position: absolute;
    right: 0;
    top: px2vh(-42);
    font-size: 24px;
    cursor: pointer;
    width: px2vh(30);
    height: px2vh(30);
  }

  .product-img {
    width: px2vh(360);
    height: px2vh(405);
    margin: 0 auto;
    display: block;
  }

  .product-name {
    font-family: SourceHanSansCN-Bold;
    font-size: px2vh(24);
    color: #000000;
    letter-spacing: px2vh(0.6);
    text-align: center;
    line-height: px2vh(48);
    font-weight: normal;
    width: px2vh(380);
    margin: 0 auto;

    &.two {
      line-height: px2vh(40);
    }
  }

  .spotlight {
    padding: px2vh(20) px2vh(30) px2vh(30) px2vh(26);
    // border-bottom: px2vh(24) solid #41558C;
    // max-height: px2vh(320);
    overflow: hidden;
    color: #fff;
    box-sizing: border-box;
  }

  .more {
    clear: both;
    font-family: SourceHanSansCN-Heavy;
    font-size: px2vh(14);
    color: #41558C;
    letter-spacing: px2vh(0.28);
    text-align: center;
    line-height: px2vh(20);
    text-decoration: underline;
    display: block;
    margin-bottom: px2vh(10);
    font-weight: 400;
  }
}
</style>
<style lang="scss">
@use "sass:math";

@function px2vh($px) {
  @return math.div(100px * $px, 1080px) * 1vh;
}

.spotlight ul li {
  font-family: SourceHanSansCN-Regular;
  font-size: px2vh(14);
  color: #000;
  letter-spacing: px2vh(0.28);
  line-height: px2vh(28);
  // margin-bottom: px2vh(4);
  padding-left: px2vh(14);
  display: -webkit-box;
  /* 设置为 WebKit 内核的弹性盒子模型 */
  -webkit-box-orient: vertical;
  /* 垂直排列 */
  -webkit-line-clamp: 2;
  /* 限制显示三行 */
  overflow: hidden;
  /* 隐藏超出范围的内容 */
  text-overflow: ellipsis;
  /* 使用省略号 */
  position: relative;

  &::before {
    content: "•";
    position: absolute;
    top: 0;
    left: 0;
    color: #000;
  }
}
</style>
